export class Collection<T> {
    constructor(result: { items: T[]; totalCount?: number; totalItemCount?: number }) {
        this.items = result.items;
        // @TODO: Fix this "totalItemCount" should be the key used as that is what the api returns and makes sense
        this.totalCount = (result.totalCount || result.totalItemCount) as number;
    }

    items: T[];
    totalCount: number;
}

export const isCollection = <T>(data: unknown): data is Collection<T> => {
    if (data == null || typeof data !== "object" || !("items" in data)) {
        return false;
    }
    const candidate = data as { items?: unknown };
    return Array.isArray(candidate.items);
};

export const isCollectionArray = <T>(data: unknown): data is Collection<T>[] =>
    data != null && Array.isArray(data) && (data.length === 0 || (data[0] != null && "items" in data[0]));
